module.exports = __webpack_public_path__ + "static/img/role0012.c5ead1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0012.jpg
// module id = hzcm
// module chunks = 1